import { USDC_ADDRESS, WNATIVE_ADDRESS } from './addresses'

import { ChainId } from '../enums'
import { Token } from '../entities/Token'
import { TokenMap } from '../types/TokenMap'

export const USDC: TokenMap = {
  [ChainId.AVALANCHE]: new Token(ChainId.AVALANCHE, USDC_ADDRESS[ChainId.AVALANCHE], 6, 'USDC', 'USD Coin'),
  [ChainId.AVALANCHE_TESTNET]: new Token(
    ChainId.AVALANCHE_TESTNET,
    USDC_ADDRESS[ChainId.AVALANCHE_TESTNET],
    6,
    'USDC',
    'USD Coin'
  ),
}

export const WETH9: TokenMap = {
  [ChainId.AVALANCHE]: new Token(ChainId.AVALANCHE, WNATIVE_ADDRESS[ChainId.AVALANCHE], 18, 'WAVAX', 'Wrapped AVAX'),
  [ChainId.AVALANCHE_TESTNET]: new Token(
    ChainId.AVALANCHE_TESTNET,
    WNATIVE_ADDRESS[ChainId.AVALANCHE_TESTNET],
    18,
    'WAVAX',
    'Wrapped AVAX'
  ),
}

export const WNATIVE: TokenMap = {
  [ChainId.AVALANCHE]: WETH9[ChainId.AVALANCHE],
  [ChainId.AVALANCHE_TESTNET]: WETH9[ChainId.AVALANCHE_TESTNET],
}
